import { FC, useState, useEffect, useCallback } from 'react'

import { Tab } from 'components'
import { useLocation } from 'react-router-dom'

import AnalyzePendingCre from './components/AnalyzePendingCre/AnalyzePendingCre'
import CheckListPending from './components/CheckListPending/CheckListPending'
import PendingCreSearch from './components/PendingCreSearch/PendingCreSearch'

const PendingAnalysisCre: FC = () => {
  const location = useLocation<any>()
  const tabs = ['Pesquisar', 'Pendências CRE', 'Pendências Checklist']
  const [selectedTab, setSelectedTab] = useState(0)
  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const handleComeBack = useCallback(() => {
    if (location?.state?.tab) {
      setSelectedTab(location?.state?.tab)
    }
  }, [location])
  useEffect(() => {
    handleComeBack()
  }, [handleComeBack])
  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <PendingCreSearch />}
      {selectedTab === 1 && <AnalyzePendingCre />}
      {selectedTab === 2 && <CheckListPending />}
    </>
  )
}

export default PendingAnalysisCre
